import { render, staticRenderFns } from "./SettlementPreview.vue?vue&type=template&id=1b16aa96"
import script from "./SettlementPreview.vue?vue&type=script&lang=js"
export * from "./SettlementPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports